import { SensorCableTagPayload, SensorTagSlot } from 'icreate/common/models/sensor-cable-tag';
import { ThermalKRows } from 'icreate/common/models/sensor-cable-tag-print';
import { terminalType, TerminalType } from 'icreate/common/models/slot';

export function getSensorData(sensorRows: any, slot: SensorTagSlot, outputType: TerminalType): SensorCableTagPayload[] {
    const slotType = slot.ioType;
    if (slotType == 'DI') return getDISensors(sensorRows, slot);
    else if (slotType == 'DO') {
        if (outputType == terminalType.normal) return getDONormalSensors(sensorRows, slot);
        if (outputType == terminalType.relay) return getDORelaySensors(sensorRows, slot);
    } else if (slotType == 'AI (Pt100 3-wire)') return getAI3TypeSensors(sensorRows, slot);
    else if (slotType == 'AI (4-20mA)' || slotType == 'AI (Pt100 2-wire)' || slotType == 'AI (1-5V)') {
        return getAITypeSensors(sensorRows, slot);
    } else if (slotType == 'AI (Thermal K)') return getThermalKSensors(sensorRows, slot);
    else if (slotType == 'AO (4-20mA)') return getOutputTypeSensors(sensorRows, slot);

    return [];
}

function getCellData(data: string) {
    if (!data) return null;
    if (data.length == 0) return null;

    return data;
}

function getDISensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors: SensorCableTagPayload[] = sensorRows.map(sensorArray => {
        return {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray[0]),
            pinNum: sensorArray[4],
            wireMark: [getCellData(sensorArray[5])],
            wireMarkClass: [getCellData(sensorArray[7])],
            coreNoIn: [getCellData(sensorArray[8])],
            coreNoCom: [getCellData(sensorArray[9])],
            dist: [getCellData(sensorArray[10])],
        };
    });
    return sensors;
}

function getDONormalSensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors: SensorCableTagPayload[] = sensorRows.map(sensorArray => {
        return {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray[0]),
            pinNum: sensorArray[3],
            wireMark: [getCellData(sensorArray[4])],
            wireMarkClass: [getCellData(sensorArray[6])],
            coreNoIn: [getCellData(sensorArray[7])],
            coreNoCom: [getCellData(sensorArray[8])],
            dist: [getCellData(sensorArray[9])],
        };
    });
    return sensors;
}

function getDORelaySensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors: SensorCableTagPayload[] = [];
    for (let i = 0; i < sensorRows.length; i += 3) {
        const sensorArray1 = sensorRows[i];
        const sensorArray2 = sensorRows[i + 1];
        const sensorArray3 = sensorRows[i + 2];

        const sensor: SensorCableTagPayload = {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray1[0]),
            pinNum: sensorArray1[3],
            wireMark: [getCellData(sensorArray1[4]), getCellData(sensorArray2[4]), getCellData(sensorArray3[4])],
            outCoreNo: [getCellData(sensorArray1[6]), getCellData(sensorArray2[6]), getCellData(sensorArray3[6])],
            wireMarkClass: [getCellData(sensorArray1[7]), getCellData(sensorArray2[7]), getCellData(sensorArray3[7])],
            dist: [getCellData(sensorArray1[8]), getCellData(sensorArray2[8]), getCellData(sensorArray3[8])],
        };
        sensors.push(sensor);
    }
    return sensors;
}

function getAI3TypeSensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors: SensorCableTagPayload[] = [];
    for (let i = 0; i < sensorRows.length; i += 3) {
        const sensorArray1 = sensorRows[i];
        const sensorArray2 = sensorRows[i + 1];
        const sensorArray3 = sensorRows[i + 2];

        const sensor: SensorCableTagPayload = {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray1[0]),
            pinNum: sensorArray1[6],
            wireMark: [getCellData(sensorArray1[7]), getCellData(sensorArray2[7]), getCellData(sensorArray3[7])],
            wireMarkClass: [getCellData(sensorArray1[9]), getCellData(sensorArray2[9]), getCellData(sensorArray3[9])],
            coreNoIn: [getCellData(sensorArray1[10]), getCellData(sensorArray2[10]), getCellData(sensorArray3[10])],
            coreNoCom: [getCellData(sensorArray1[11]), getCellData(sensorArray2[11]), getCellData(sensorArray3[11])],
            dist: [getCellData(sensorArray1[12]), getCellData(sensorArray2[12]), getCellData(sensorArray3[12])],
        };
        sensors.push(sensor);
    }
    return sensors;
}

function getAITypeSensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors = sensorRows.map(sensorArray => {
        return {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray[0]),
            pinNum: sensorArray[6],
            wireMark: [getCellData(sensorArray[7])],
            wireMarkClass: [getCellData(sensorArray[9])],
            coreNoIn: [getCellData(sensorArray[10])],
            coreNoCom: [getCellData(sensorArray[11])],
            dist: [getCellData(sensorArray[12])],
        };
    });
    return sensors;
}

function getThermalKSensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors = sensorRows.map((sensorArray, index) => {
        let pinNum = sensorArray[5];
        if (isNaN(pinNum)) {
            const match = pinNum.match(/COM\s*(\d+)/i);
            const comPin = match ? parseInt(match[1], 10) : null;
            pinNum = comPin + ThermalKRows;
        }
        return {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray[0]),
            pinNum: pinNum,
            wireMark: [getCellData(sensorArray[6])],
            wireMarkClass: [getCellData(sensorArray[8])],
            coreNoIn: [getCellData(sensorArray[9])],
            coreNoCom: [getCellData(sensorArray[10])],
            dist: [getCellData(sensorArray[11])],
        };
    });
    return sensors;
}

function getOutputTypeSensors(sensorRows: any[], slot: SensorTagSlot): SensorCableTagPayload[] {
    const sensors = sensorRows.map(sensorArray => {
        return {
            fcuNum: slot.fcuNum,
            fuNum: slot.fuNum || 0,
            vesselId: slot.vesselId,
            slotId: slot.slotId,
            slotNum: slot.no,
            id: getCellData(sensorArray[0]),
            itemName: getCellData(sensorArray[1]),
            pinNum: sensorArray[2],
            wireMark: [getCellData(sensorArray[3])],
            wireMarkClass: [getCellData(sensorArray[5])],
            coreNoIn: [getCellData(sensorArray[6])],
            coreNoCom: [getCellData(sensorArray[7])],
            dist: [getCellData(sensorArray[8])],
        };
    });
    return sensors;
}
